import type React from 'react';

const HaufeGroupLogo: React.FC<{ width?: number; height?: number; className?: string }> = ({
  width = 130,
  height = 22,
  className = '',
}) => {
  const logoSrc = '/assets/haufe-group-logo/hg-logo-singleline.svg';

  return (
    <img
      src={logoSrc}
      alt="Haufe Group Logo"
      width={width}
      height={height}
      className={className}
      loading="lazy"
      decoding="async"
    />
  );
};

export default HaufeGroupLogo;
